import axios from "axios";
import { BACKEND_URL } from "../config";
import { EmbeddedApp } from "../App";
import { Redirect } from "@shopify/app-bridge/actions";
axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        const shopify_reauthorize_url =
            error?.response?.headers[
                "x-shopify-api-request-failure-reauthorize-url"
            ];
        if (shopify_reauthorize_url)
            EmbeddedApp.dispatch(
                Redirect.toRemote({
                    url: BACKEND_URL + shopify_reauthorize_url,
                }),
            );

        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    },
);
